import React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { Dropdown } from 'semantic-ui-react';

/**
 * Example usage:
 * <SingleDatePicker renderMonthElement={CustomMonthYearElementForDatePickerWrapper} />
 *
 * @param month
 * @param onMonthSelect
 * @param onYearSelect
 * @returns {*}
 * @constructor
 */
const MonthYearElement = ({ month, onMonthSelect, onYearSelect }) => {
  const getYearsOptions = () => {
    let yearsOptions = [];
    for (let i = -50; i <= 50; i++)
      yearsOptions.push({
        text: moment().year() + i,
        value: moment().year() + i,
        key: moment().year() + i
      });
    return yearsOptions;
  };

  const getMonthsOptions = () => {
    return moment.months().map((label, value) => ({ text: label, value: value, key: value }));
  };

  const yearsOptions = getYearsOptions();
  const monthsOptions = getMonthsOptions();

  //hidding default week days is a work around because otherwise they appear above dropdown, even if adding zIndexes
  return (
    <>
      <Dropdown
        className="DayPicker_weekHeader_ul customMonthYearElement"
        style={{ width: '112px' }}
        selection
        compact
        value={month.month()}
        onChange={(e, v) => onMonthSelect(month, v.value)}
        options={monthsOptions}
      />
      <Dropdown
        className="DayPicker_weekHeader_ul customMonthYearElement"
        style={{ width: '67px' }}
        selection
        compact
        value={month.year()}
        onChange={(e, v) => onYearSelect(month, v.value)}
        options={yearsOptions}
      />
      <div className="DayPicker_weekHeader">
        <ul className="DayPicker_weekHeader_ul">
          {moment.weekdaysMin().map(day => (
            <li key={day} style={{ width: '39px' }} className="DayPicker_weekHeader_li">
              {day}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default MonthYearElement;
